export default __webpack_public_path__ + "static/media/1161.b03bc811.png";